import { useEffect, useState } from 'react';
import { usePublishNotification } from '@yakoffice/notification-handler';
import { useRootStore } from './useRootStore';
import { IProject } from '../model/project/Project';

interface useProjectsResult {
    isLoaded: boolean;
    projects: IProject[] | null;
}

export const useProjects = (projectId: string) => {

    const rootStore = useRootStore();
    const publishNotification = usePublishNotification();

    const [result, setResult] = useState<useProjectsResult>({ isLoaded: false, projects: [] });

    useEffect(() => {
        setResult({ isLoaded: false, projects: [] });

        rootStore.projectStore.loadProject(projectId)
            .then(() => {
                setResult({ isLoaded: true, projects: rootStore.projectStore.projects });
            })
            .catch(() => {
                    setResult({ isLoaded: true, projects: [] });
                }
            );
    }, [rootStore.projectStore, publishNotification]);

    return result;
};
